<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap -mb-1">
      <template v-for="(link, key) in links" :key="key">
        <div v-if="link.url === null"
          class="px-4 py-3 mr-1 mb-1 text-sm leading-4 text-gray-400 rounded border dark:text-gray-600 focus:border-green-500 focus:text-green-500"
          v-html="link.label"
        />
        <button
          v-else
          class="px-4 py-3 mr-1 mb-1 text-sm leading-4 text-black rounded border dark:text-white hover:bg-green-200 hover:text-green-600 focus:border-green-500 focus:text-green-500"
          :class="{ 'bg-green-600 text-white': link.active }"
          :disabled="!link.url || link.active"
          @click="onPageChange(link)"
          v-html="link.label"
        />
      </template>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  links: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['page-change'])

function onPageChange(link) {
  if (!link.url || link.active) return;
  // Try to extract 'page' param from the url
  const url = link.url;
  const match = url.match(/[?&]page=(\d+)/);
  const page = match ? parseInt(match[1], 10) : 1;
  emit('page-change', page);
}

</script>
